import { ApiResponse } from './api-response';

/**
 * Api paginated response of T
 */
export class ApiPaginatedResponse<T> extends ApiResponse<T> {
	page!: number;
	pageSize!: number;
	totalCount?: number;
	totalPages?: number;
	hasPreviousPage?: boolean;
	hasNextPage?: boolean;
}
